import { TwoFactorAuthMethodType } from "./TwoFactorAuthMethodType";

export class TwoFactorAuthSettingsModel {
    methods: KnockoutObservableArray<TwoFactorAuthSettingsMethod> = ko.observableArray([]);
}

export class TwoFactorAuthSettingsMethod {
    id: number;
    methodType: TwoFactorAuthMethodType;
    methodTypeDescription: string;
    name: string;
    isDefault: boolean;

    isDefaultDesc = ko.pureComputed(() => {
        return this.isDefault ? "YES" : "NO";
    }, this);

    methodTypeCssClass = ko.pureComputed(() => {
        switch (this.methodType) {
            case TwoFactorAuthMethodType.AuthenticatorApplication:
                return "fa fa-mobile";

            default:
                return "test";
        }
    }, this);
}
